/** Motivo de decision: obligatorio al rechazar (Yup, con su test). */
import * as yup from 'yup';

export const taskDecisionSchema = yup.object({
  decision: yup.string().oneOf(['approve', 'reject']).required(),
  reason: yup.string().trim().max(2000, 'El motivo es muy largo').default(''),
});

export type TaskDecisionForm = yup.InferType<typeof taskDecisionSchema>;

export function decisionError(values: TaskDecisionForm): string | null {
  if (values.decision === 'reject' && values.reason.trim() === '') {
    return 'El rechazo exige un motivo';
  }
  return null;
}
